import { render } from "./SalesLeadTransfers.vue?vue&type=template&id=265e35a3&scoped=true&ts=true"
import script from "./SalesLeadTransfers.vue?vue&type=script&lang=ts"
export * from "./SalesLeadTransfers.vue?vue&type=script&lang=ts"

import "./SalesLeadTransfers.vue?vue&type=style&index=0&id=265e35a3&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e35a3"]])

export default __exports__